import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { T } from '@design/index';
import { scrollBody, actionBtn, card, ProgressHeader, WebEntryLayout } from './entryHelpers';
import { patientAuthFlow } from '../../auth/patientAuthFlow';

const labelStyle: React.CSSProperties = {
  fontSize: 9,
  fontWeight: 600,
  color: T.textTer,
  fontFamily: T.font,
  marginBottom: 4,
};

const fieldStyle: React.CSSProperties = {
  width: '100%',
  padding: '10px 14px',
  borderRadius: 10,
  border: `1px solid ${T.border}`,
  background: T.ice,
  fontSize: 12,
  fontFamily: T.mono,
  color: T.textTer,
  outline: 'none',
  boxSizing: 'border-box',
};

export default function PatRegAbhaScreen() {
  const navigate = useNavigate();
  const [abhaNumber, setAbhaNumber] = useState('');

  return (
    <WebEntryLayout>
    <div style={{ flex: 1, background: T.white, display: 'flex', flexDirection: 'column', fontFamily: T.font }}>
      <ProgressHeader title="ABHA / Health IDs" step={6} total={8} onBack={() => navigate(-1)} />

      <div style={scrollBody}>
        <div style={card()}>
          {/* Shield Icon */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: 10,
                background: `${T.navy}1A`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <svg width={18} height={18} viewBox="0 0 24 24" fill="none" stroke={T.navy} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 1L2 5v8c0 7 4.3 11 10 13 5.7-2 10-6 10-13V5L12 1z" />
              </svg>
            </div>
            <div>
              <div style={{ fontSize: 12, fontWeight: 700, color: T.text, fontFamily: T.font }}>Link ABHA ID</div>
              <div style={{ fontSize: 9, color: T.textSec, fontFamily: T.font }}>Ayushman Bharat Health Account</div>
            </div>
          </div>

          {/* ABHA Number Input */}
          <div>
            <div style={labelStyle}>ABHA Number</div>
            <input
              type="text"
              placeholder="14-xxxx-xxxx-xxxx"
              value={abhaNumber}
              onChange={(e) => setAbhaNumber(e.target.value)}
              style={fieldStyle}
            />
          </div>

          {/* Explanation */}
          <div style={{ fontSize: 9, color: T.textSec, fontFamily: T.font, lineHeight: 1.6, marginTop: 10 }}>
            Linking your ABHA ID is optional. It enables seamless sharing of health records across
            hospitals and clinics participating in the Ayushman Bharat Digital Mission.
          </div>
        </div>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: 10 }}>
          <button
            onClick={() => {
              patientAuthFlow.completeAbha('skipped');
              navigate('/patient/register/consent');
            }}
            style={{
              ...actionBtn('Skip for Now', T.textSec, T.textSec, true),
              flex: 1,
              padding: 13,
              borderRadius: 12,
              fontSize: 13,
            }}
          >
            Skip for Now
          </button>
          <button
            onClick={() => {
              // No ABDM integration exists — the number is saved as
              // self-reported, never asserted as a verified "linked" status.
              patientAuthFlow.completeAbha('self_reported', abhaNumber);
              navigate('/patient/register/consent');
            }}
            style={{
              ...actionBtn('Save ABHA (unverified)', T.navy, T.white),
              flex: 1,
              padding: 13,
              borderRadius: 12,
              fontSize: 13,
            }}
          >
            Save ABHA (unverified)
          </button>
        </div>
      </div>
    </div>
    </WebEntryLayout>
  );
}
